export class IncomingFilter {
    id: number;
    num: string;
    name: string;
    taken: string;
    deadline: string;
    userId: string;
}